import { PrinterSlimContract } from 'models'
import { PrinterSettings } from '../types'
import getEnv from 'utilities/getEnv'
const CURRENT_LOCATION_TENANT_ID = getEnv(
    'REACT_APP_LOCATION_TENANT_IDENTIFIER_ID',
)
export const convertPrinterContractToPrinterSetting = (
    printer: PrinterSlimContract,
): PrinterSettings => {
    return {
        printerID: printer.printerID!,
        printerType: printer.printerType!,
        iPAddress: printer.ip,
        port: printer.port ? Number(printer.port) : 0,
        com: printer.com,
        baudRate: printer.baudRate,
        pid: printer.pid,
        vid: printer.vid,
        locationID: CURRENT_LOCATION_TENANT_ID,
        printCoolDownDelay: printer.printCoolDownDelay,
        networkPrinterWritterType: printer.networkPrinterWritterType,
        printImageDelay: printer.printImageDelay,
    }
}
